export const COMPLIANT_STATUS = {
  PENDING: "Pending",
  RETURNED: "Returned",
  UNDER_INVESTIGATION: "Under Investigation",
  CLOSED: "Closed",
  TERMINATED: "terminated",
  DRAFT_CHARGE: "Draft Charge",
  DRAFT_CHARGE_UPDAED: "Draft Charge Updated",
  UNDER_LITIGATION: "Under Litigation",
  APPEALED: "Appealed",
  COUNCIL_OFFICE: "Council Office",
  FINAL_DECISION: "Final Decision",
  REJECTED: "Rejected",
  ON_PANEL: "on_panel",
  ASSIGNED_TO_PROSECUTOR: "Assigned To Prosecutor",
  FORWARDED_TO_COUNCIL_WRITER: "Forwarded_to_council_writer",
  FORWARDED: "Forwarded",
  COMPLETED: "Completed",
  SUMMON_ISSUED: "Summon Issued",
  MORE_INFORMATION_REQUESTED: "More information requested",
  APPEAL_REJECTED_FOR_INSPECTION: "Appeal Rejected For Inspection",
  COUNCIL_VERDICT_ISSUED: "Council Verdict Issued",
  FURTHER_INVESTIGATION: "Further Investigation",
  DECISION_ISSUED: "Decision Issued",
  REJECTED_BY_COUNCIL_OFFICE: "Rejected by Council Office",
};

export const INVESTIGATION_STATUS = {
  PENDING: "Pending",
  UNDER_INVESTIGATION: "Under investigation",
  CLOSED: "Closed",
  ON_CHARGE: "On Charge",
  BACK_TO_PROSECUTOR: "Back to Prosecutor",
  FORWARDED_TO_REGISTRAR: "Forwareded to Registrar",
  FORWARDED_TO_COUNCIL: "Forwareded to Council Office",
  FORWARDED_TO_HEAD: "Forwareded to Council Head",
};
export const ADVOCATE_INVESTIGATION_STATUS = {
  PENDING: "Pending",
  RETURNED: "Returned",
  UNDER_INVESTIGATION: "Under investigation",
  CLOSED: "Closed",
  ON_CHARGE: "On Charge",
  BACK_TO_PROSECUTOR: "Back to Prosecutor",
  FORWARDED_TO_REGISTRAR: "Forwarded to Registrar",
  FORWARDED_TO_COUNCIL: "Forwarded to Council Office",
  FORWARDED_TO_HEAD: "Forwarded to Council Head",
  BACK_TO_PROSECUTOR_FROM_CORD: "Back to Prosecutor From Cord",
  INITIAL_DAY_DECISION_ISSUED: "Initial-Day Decision Issued",
  FORWARDED_TO_COORDINATOR: "Forwarded to Cordinator",
};

export const DECISION_TYPE = {
  APPROVED: "Approved",
  REVISE: "Revise",
  REJECTED: "Rejected",
  MORE_INFORMATION: "More information requested",
  JURISDICTION: "Out of jurisdiction",
};

export const DECISION_TYPE2 = {
  APPROVED: "Approved",
  REJECTED: "Rejected",
  MORE_INFORMATION: "More information requested",
  JURISDICTION: "Out of jurisdiction",
};

export const PROSECUTOR_DECISION_TYPE = {
  FRAME_CHARGE: "Frame a charge",
  INSUFFICIENT_EVIDENCE: "Insufficient Evidence",
  // CLOSE_CASE: "Close the Case",
  FURTHER_INVESTIGATION: "Further Investigation",
};
export const PROSECUTOR_DECISION_TYPE2 = {
  FRAME_CHARGE: "Frame a charge",
  CLOSE_THE_CASE: "Close the Case",
};

export const SUMMON_STATUS = {
  PENDING: "Pending",
  CLOSED: "Closed",
  SUMMON_ISSUED: "Summon Issued",
  FORWARDED_TO_COUNCIL_OFFICE: "Forwareded to Council Writer",
  FORWARDED_TO_COUNCIL_HEAD: "Forwareded to Council Head",
  FORWAREDED_TO_ACCUSED: "Forwareded to Accused",
};
export const ADVOCATE_SUMMON_STATUS = {
  PENDING: "Pending",
  CLOSED: "Closed",
  SUMMON_ISSUED: "Summon Issued",
  SUMMON_FORWARDED_TO_COUNCIL_OFFICE: "forwarded_to_council_writer",
  FORWARDED_TO_COUNCIL_OFFICE: "Forwarded to Council Writer",
  FORWARDED_TO_COUNCIL_HEAD: "Forwarded to Council Head",
  FORWAREDED_TO_ACCUSED: "Forwarded to Accused",
  FORWARDED_TO_REGISTRAR_FOR: "Forwarded to Registrar For",
};

export const FEEDBACK_TYPE = {
  APPROVED: "Approve",
  REVISE: "Revise",
  REJECT_TO_CLOSE: "reject_to_close",
};

export const FEEDBACK_TYPE2 = {
  APPROVED: "Approve",
  REVISE: "Revise",
};

export const APPEAL_STATUS = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
  REVISION_REQUIRED: "revision",
  FORWARDED_TO_COUNCIL: "forwarded_to_council_head",
  FORWARDED_TO_REGISTRAR: "forwarded_to_registrar",
  TO_COUNCIL_HEAD: "forwarded_to_council_head",
  FORWARDED_TO_COUNCIL_OFFICE: "forwarded_to_council_office",
  FORWARDED_TO_COUNCIL_WRITER: "forwarded_to_council_writer",
  UPDATED: "updated",
};
export const ADVOCATE_APPEAL_STATUS = {
  APPROVED: "approved",
  PENDING: "pending",
  REJECTED: "rejected",
  revision: "revision",
  FORWARD_TO_COUNCIL_OFFICE: "forwarded_to_council_office",
  FORWARD_TO_COUNCIL_WRITER: "forwarded_to_council_writer",
  FORWARD_TO_COUNCIL_HEAD: "forwarded_to_council_head",
  FORWARD_TO_REGISTRAR: "forwarded_to_registrar",
  ON_PANEL: "on_panel",
};

export const PROSECUTOR_APPEAL_OPINION = {
  APPEAL: "Appeal",
  NOT_APPEAL: "Not appeal",
};

export const APPEAL_TYPE = {
  INSPECTION_PROSECUTOR_TO_COUNCIL_OFFICE: "inspection_to_council",
  ACCUSED_PROSECUTOR_TO_COURT: "inspection_to_court",
};

export const APPEAL_FEEDBACK_TYPE = {
  APPROVED: "approved",
  RESPOND_BACK: "respond_back",
};
export const ADVOCATE_APPEAL_FEEDBACK_TYPE = {
  APPROVED: "Approve",
  RESPOND_BACK: "Revise",
};

export const ACCUSED_COMPLAINT_STATUS = {
  PENDING: "Pending",
  REJECTED: "rejected",
  REVISION: "revision",
  APPROVED: "approved",
  FORWARDED_TO_COORDINATOR: "forwarded_to_coordinator",
  FORWARDED_TO_COUNCIL_OFFICE: "Forwarded_to_council_writer",
  FORWARDED_TO_REGISTRAR: "forwarded_to_registrar",
  ASSIGNED_TO_PROSECUTOR: "assigned_to_prosecutor",
};

export const ADVOCATE_ACCUSED_COMPLAINT_STATUS = {
  PENDING: "Pending",
  REJECTED: "rejected",
  REVISION: "revision",
  APPROVED: "approved",
  FORWARDED_TO_REGISTRAR: "forwarded_to_registrar",
  FORWARDED_TO_COUNCIL_OFFICE: "Forwarded_to_council_writer",
  FORWARDED_TO_COORDINATOR: "forwarded_to_coordinator",
  ASSIGNED_TO_PROSECUTOR: "assigned_to_advocate",
};

export const COURT_APPEAL_STATUS = {
  PENDING: "pending",
  REJECTED: "rejected",
  REVISION: "revision",
  APPROVED: "approved",
  FORWARDED_TO_COORDINATOR: "forwarded_to_coordinator",
  ASSIGNED_TO_PROSECUTOR: "assigned_to_prosecutor",
};

export const ADVOCATE_COURT_APPEAL_STATUS = {
  PENDING: "pending",
  REJECTED: "rejected",
  REVISION: "revision",
  APPROVED: "approved",
  FORWARDED_TO_COORDINATOR: "forwarded_to_coordinator",
  FORWARDED_TO_REGISTRAR: "forwarded_to_rigistrar",
  ASSIGNED_TO_PROSECUTOR: "assigned_to_advocate",
};

export const APPOINTMENT_REASON = {
  VERBAL_LITIGATION: "verbal litigation",
  EVIDENCE_INSPECTION: "evidence inspection",
  EVIDENCE_DEFENSE: "evidence defence",
  FINAL_DECISION: "final decision",
};

export const APPEAL_APPOINTMENT_REASON = {
  VERBAL_LITIGATION: "litigation",
  ADDITIONAL_INVESTIGATION: "aditiona investigation",
  ADDITIONAL_EVIDENCE: "additional evidence",
  FINAL_DECISION: "final decision",
};

export const HIERARCHY_LEVELS = {
  REGIONAL: "Regional",
  ZONAL: "Zonal",
};

export const OFFENSE_TYPE = {
  GRAVE_OFFENSE: "grave",
  MEDIUM_OFFENSE: "medium",
  PITY_OFFENSE: "pity",
};

export const REGIONS = ["Region 1", "Region 2", "Region 3"];
export const ZONES = ["Zone 1", "Zone 2", "Zone 3"];
export const WOREDAS = ["Woreda 1", "Woreda 2", "Woreda 3"];
export const KEBELES = ["Kebele 1", "Kebele 2", "Kebele 3"];
